/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/bit_length.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the bit length of a string.
 *
 * Note: All strings are in UTF-8, so a single character can use multiple bytes.
 *
 * @example
 * FROM airports
 * | WHERE country == "India"
 * | KEEP city
 * | EVAL fn_length = LENGTH(city), fn_bit_length = BIT_LENGTH(city)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'bit_length',
  signatures: [
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
